import { render, staticRenderFns } from "./devisBar.vue?vue&type=template&id=54bc58a0&scoped=true"
import script from "./devisBar.vue?vue&type=script&lang=js"
export * from "./devisBar.vue?vue&type=script&lang=js"
import style0 from "./devisBar.vue?vue&type=style&index=0&id=54bc58a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54bc58a0",
  null
  
)

export default component.exports